// extracted by mini-css-extract-plugin
export default {"input":"styles_input__MCqAd","container":"styles_container__+6PXV","toggle":"styles_toggle__h-qyB","active":"styles_active__Iz1u8","label":"styles_label__d7ssa"};